<div>
  <app-composition-filters *ngIf="years"
    [years]="years"
    [categories]="categories"
    [countryCategory]="countryCategory"
    (loadCategories)="loadCategories($event)"
    (search)="searchData($event)">
  </app-composition-filters>
  <mat-divider></mat-divider>
  <app-composition-pie-chart *ngIf="data"
    [title]="text"
    [subtitle]="subtitle"
    [countryCategory]="countryCategory"
    [countries]="dataCountries"
    [displayUnits]="displayUnits"
    [data]="data">
  </app-composition-pie-chart>
</div>
